﻿import logo from '@assets/logo.svg';
import { Box, Button } from '@atgfr8/atg-ui-tailwind';
import { useNavigate } from '@solidjs/router';
import { ConfigManager } from '@utils/ConfigManager';

export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      class={`p-[8px] bg-[#e1ecf2] ${
        ConfigManager.showLayout ? 'h-screen' : ' h-full'
      } `}
    >
      {/* If `shadow-xl` isn't right, apply: box-shadow: 0px 0px 8px 0px; */}
      <Box class="h-full bg-white rounded-xl shadow-lg flex justify-center items-center">
        <Box class="flex flex-col items-center">
          <Box class="flex flex-row items-center justify-center gap-5">
            <img src={logo} class="inline-block" height="45px" />
            <h1 class="text-5xl">404 - Lost in Transit</h1>
          </Box>
          <Box class="text-2xl flex flex-col items-center mt-[20px]">
            <Box class="mb-[10px]">
              The page you're looking for does not exist.
            </Box>
            <Box>
              <Button
                variant="contained"
                onClick={() => {
                  navigate('/loadboard');
                }}
                dataTestId="not-found-go-loadboard-button"
              >
                Go to Loadboard
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
